import { Directive, Input, ElementRef, ViewContainerRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[fieldValidation]'
})
export class FieldValidationDirective implements OnInit {
  @Input('fieldValidation') field;
  parentComponent: any;

  constructor(private el: ElementRef, private renderer: Renderer2, private vcRef: ViewContainerRef) {
    console.log('im here');
    this.parentComponent = (<any>this.vcRef.injector).view.component
    
  }

  ngOnInit() {
    console.log(this.el);
    console.log( this.parentComponent, this.field);
  }
}
